"use client";

import React from "react";
import { useTranslation } from "@/hooks/useTranslation";
import Wrapper from "@/components/organisms/Wrapper";
import { useGetCopyright } from "./hooks/useGetDisclaimer";
import "./styles.scss";

type FooterCopyrightProps = {
  company: string;
  className?: string;
};

const FooterCopyright = ({ company, className }: FooterCopyrightProps) => {
  const { t } = useTranslation("footer");
  const copyRight = useGetCopyright(company, t);

  const classNames = "footer--copyright" + (className ? ` ${className}` : "");

  return (
    <div className={classNames}>
      <Wrapper>{copyRight}</Wrapper>
    </div>
  );
};

export default FooterCopyright;
